const DETAILS_ACTION_TYPES = {
  FETCH_DETAILS: "FETCH_DISCIPLE_DETAILS",
  FETCH_DETAILS_REQUEST: "FETCH_DISCIPLE_DETAILS_REQUEST",
  FETCH_DETAILS_SUCCESS: "FETCH_DISCIPLE_DETAILS_SUCCESS",
  FETCH_DETAILS_FAILURE: "FETCH_DISCIPLE_DETAILS_FAILURE",
  INVALIDATE_DETAILS: "INVALIDATE_DISCIPLE_DETAILS",
}

export default DETAILS_ACTION_TYPES
